import React from 'react';

interface Scroll {
  children: React.ReactNode;
}

const Scroll = ({ children }: Scroll) => (
  <div className="whatcrm-widget-scroll">{children}</div>
);

export default Scroll;
